import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSuperAdmin } from '../../contexts/SuperAdminContext';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Shield, Loader2, AlertCircle } from 'lucide-react';

export default function SuperAdminLogin() {
  const { login, isAuthenticated } = useSuperAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    navigate('/superadmin/dashboard', { replace: true });
    return null;
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/superadmin/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="superadmin-login-page">
      <Card className="w-full max-w-sm border-slate-200 shadow-lg">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto w-12 h-12 bg-slate-900 rounded-xl flex items-center justify-center mb-3">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <CardTitle className="text-lg font-bold text-slate-900">Super Admin</CardTitle>
          <p className="text-xs text-slate-500 mt-1">Inspiro Tracker Product Console</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            {error && (
              <div className="flex items-center gap-2 p-2.5 bg-red-50 border border-red-200 rounded-lg text-xs text-red-700" data-testid="login-error">
                <AlertCircle className="w-3.5 h-3.5 flex-shrink-0" />
                {error}
              </div>
            )}
            <div className="space-y-1.5">
              <Label className="text-xs text-slate-600">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="superadmin@..."
                className="h-9 rounded-lg text-sm"
                required
                data-testid="sa-email-input"
              />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs text-slate-600">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                className="h-9 rounded-lg text-sm"
                required
                data-testid="sa-password-input"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-9 rounded-xl bg-slate-900 hover:bg-slate-800" data-testid="sa-login-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Sign In'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
